import { render, staticRenderFns } from "./general_content.vue?vue&type=template&id=edc610bc&scoped=true&"
import script from "./general_content.vue?vue&type=script&lang=js&"
export * from "./general_content.vue?vue&type=script&lang=js&"
import style0 from "./general_content.vue?vue&type=style&index=0&id=edc610bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc610bc",
  null
  
)

export default component.exports